// 📁 stakeholderOverlay.js
export default function showMiroBoard() {
    // Bereits vorhanden? Entfernen
    const existing = document.getElementById('miroBoard-overlay')
    if (existing) existing.remove()

    // Overlay
    const overlay = document.createElement('div')
    overlay.id = 'miroBoard-overlay'
    overlay.style.position = 'fixed'
    overlay.style.top = 0
    overlay.style.left = 0
    overlay.style.width = '100vw'
    overlay.style.height = '100vh'

    overlay.style.display = 'flex'
    overlay.style.justifyContent = 'center'
    overlay.style.alignItems = 'center'
    overlay.style.zIndex = 9999
    overlay.style.animation = 'fadeIn 0.4s ease-out'

    // Box
    const box = document.createElement('div')
    box.style.width = '60vw'
    box.style.maxWidth = '800px'
    box.style.background = '#ffffff'
    box.style.borderRadius = '16px'
    box.style.padding = '30px'
    box.style.textAlign = 'center'
    box.style.boxShadow = '0 0 25px rgba(0,0,0,0.3)'
    box.style.animation = 'popUp 0.4s ease-out'
    box.style.position = 'relative'

    // Miro Logo
    const logo = document.createElement('img')
    logo.src ='images/miro.png'
    logo.alt = 'Miro Logo'
    logo.style.width = '80px'
    logo.style.marginBottom = '20px'
    logo.style.opacity = '0.9'
    box.appendChild(logo)

    // Text
    const text = document.createElement('p')
    text.style.fontSize = '1.1rem'
    text.style.lineHeight = '1.5'
    text.style.marginBottom = '20px'
    text.innerHTML = `
        Mit Veränderungen gehen auch immer Ängste und Widerstände einher, ganz allgemein und natürlich auch bei technologischen Neuerungen im Arbeitskontext. <br><br>
        Mit der Einführung von KI ist das Auftreten von Widerständen oft verstärkt, da sich das Feld rasend schnell entwickelt, 
        noch viele Unsicherheiten bestehen und sich eine allgemeine und breite gesellschaftliche Akzeptanz erst entwickelt. <br><br>
         Relevane Themen sind hier zum Beispiel die Sorge vor Arbeitsplatzverlust, mangeldens Vertrauen und datenschutzrechtliche Bedenken. <br><br>
        👉 <strong>Klicken Sie hier und scrollen Sie tief, um mehr über die einzelnen Widerstände zu erfahren und bewerten Sie im Anschluss die Relevanz dieser Widerstände für Ihren eigenen Unternehmenskontext.</strong>
    `
    box.appendChild(text)

    // Link-Button
    const link = document.createElement('a')
    link.href = 'https://miro.com/app/board/uXjVJWXaOxg=/?share_link_id=718992110267'
    link.target = '_blank'
    link.textContent = '🔗 Miro Board öffnen'
    link.style.display = 'inline-block'
    link.style.padding = '12px 24px'
    link.style.backgroundColor = '#ffd02f'
    link.style.color = '#000000'
    link.style.borderRadius = '8px'
    link.style.textDecoration = 'none'
    link.style.fontWeight = 'bold'
    link.style.transition = 'transform 0.2s ease'
    link.onmouseover = () => link.style.transform = 'scale(1.05)'
    link.onmouseout = () => link.style.transform = 'scale(1)'
    box.appendChild(link)

    // Close Button
    const close = document.createElement('button')
    close.textContent = '✖'
    close.style.position = 'absolute'
    close.style.top = '20px'
    close.style.right = '30px'
    close.style.fontSize = '12px'
    close.style.background = '#f44336'
    close.style.color = '#ffffff'
    close.style.border = 'none'
    close.style.cursor = 'pointer'
    close.onclick = () => overlay.remove()
    box.appendChild(close)
    overlay.appendChild(box)
    document.body.appendChild(overlay)

    // CSS Keyframes
    const style = document.createElement('style')
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0 } to { opacity: 1 }
        }
        @keyframes popUp {
            0% { transform: scale(0.8); opacity: 0 }
            100% { transform: scale(1); opacity: 1 }
        }
    `
    document.head.appendChild(style)
}
